export default __webpack_public_path__ + "static/media/ads_six_bg.bd91e6b3.jpg";